'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserRum = require('@datadog/browser-rum');

var _DebugManager = require('./DebugManager');

var _DebugManager2 = _interopRequireDefault(_DebugManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var dmInstance = _DebugManager2.default.dmInstance;

var RUMUtil = function RUMUtil() {
  _classCallCheck(this, RUMUtil);
};

RUMUtil.init = function (appName, opts) {
  if (!appName) return;
  try {
    var ddConfig = _extends({}, RUMUtil.DatadogConfig[appName.toUpperCase()], opts);
    _browserRum.datadogRum.init(ddConfig);
    dmInstance.log('[RUMUtil] init() Datadog RUM initialized with: ' + JSON.stringify(ddConfig));
  } catch (e) {
    dmInstance.log('[RUMUtil] init() Datadog RUM error: ' + e);
  }
};

RUMUtil.startSessionReplay = function () {
  try {
    _browserRum.datadogRum.startSessionReplayRecording();
  } catch (e) {
    dmInstance.log('[RUMUtil] startSessionReplay() Datadog RUM error: ' + e);
  }
};

RUMUtil.setUser = function (user) {
  try {
    var userName = user.firstName + ' ' + user.lastName;
    _browserRum.datadogRum.setUser({ id: user.id, name: userName });
    dmInstance.log('[RUMUtil] setUser() userId: ' + user.id + ', userName: ' + userName);
  } catch (e) {
    dmInstance.log('[RUMUtil] setUser() Datadog RUM error: ' + e);
  }
};

RUMUtil.setContext = function (context) {
  try {
    _browserRum.datadogRum.addRumGlobalContext('eventData', context);
    dmInstance.log('[RUMUtil] setContext() context: ' + JSON.stringify(context));
  } catch (e) {
    dmInstance.log('[RUMUtil] setContext() Datadog RUM error: ' + e);
  }
};

RUMUtil.addAction = function (name, actionObj) {
  try {
    _browserRum.datadogRum.addAction(name, actionObj);
  } catch (e) {
    dmInstance.log('[RUMUtil] addAction() Datadog RUM error: ' + e);
  }
};

RUMUtil.addError = function (error) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    _browserRum.datadogRum.addError(error, context);
  } catch (e) {
    dmInstance.log('[RUMUtil] addError() Datadog RUM error: ' + e);
  }
};

RUMUtil.DatadogConfig = {
  BACKSTAGE: {
    name: 'backstage',
    applicationId: 'd890359a-ecad-4c7e-a0b3-6565d238865c',
    clientToken: 'pube24cf13cb75da1e96b3793e9c7ceec92',
    service: 'broadcaster-backstage',
    site: 'datadoghq.com',
    env: 'dev',
    version: '1.0.0',
    trackInteractions: true
  },
  AUDIENCE: {
    name: 'audience',
    applicationId: '9cdf52b4-edd8-4709-bfa9-a84f9179f7fb',
    clientToken: 'pub257caf4ba6144ab280ee8c888e09a46b',
    service: 'broadcaster-audience',
    site: 'datadoghq.com',
    env: 'dev',
    version: '1.0.0',
    trackInteractions: true
  }
};
exports.default = RUMUtil;